import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IFilterOptionsQueryPort } from '@service/preclinical/filter-options-query.port';
import { FilterOptionsResponse } from '@model/filter/filter-options.model';
import { IngestedOrdersService } from '@infra-services/ingested-orders/services/ingested-orders.service';

@Injectable({
  providedIn: 'root'
})
export class FilterOptionsQueryAdapter implements IFilterOptionsQueryPort {
  constructor(private readonly ingestedOrdersService: IngestedOrdersService) {}

  getFilterOptions(): Observable<FilterOptionsResponse> {
    return this.ingestedOrdersService.getFilterOptions();
  }
}
